var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEyeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.493 10.612C18.5117 8.31782 15.2679 5.94895 11.9989 6.00084C8.72992 5.94895 5.48603 8.31779 3.50674 10.6123L3.50674 10.6123L3.50462 10.6148C3.17977 10.9946 3 11.4876 3 11.9988C3 12.51 3.17977 13.0031 3.50462 13.3829L3.50462 13.3829L3.50659 13.3852C5.44092 15.629 8.67637 18.0518 11.9989 17.9992C15.3214 18.0518 18.5575 15.629 20.4932 13.3854L20.4954 13.3829C20.8202 13.0031 21 12.51 21 11.9988C21 11.4876 20.8202 10.9946 20.4954 10.6147L20.493 10.612ZM4.48612 11.9988C4.48612 11.875 4.52953 11.7555 4.60801 11.6632C6.47364 9.5011 9.34302 7.519 11.9864 7.56596H12.0114C14.6547 7.519 17.524 9.50093 19.3921 11.6633C19.4705 11.7555 19.5139 11.875 19.5139 11.9988C19.5139 12.1227 19.4705 12.2422 19.392 12.3344C17.5634 14.4533 14.7024 16.4817 12.0114 16.434H11.9864C9.29544 16.4817 6.43512 14.4533 4.60808 12.3345C4.52956 12.2423 4.48612 12.1228 4.48612 11.9988ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEyeInactive);
export default __webpack_public_path__ + "static/media/open-eye-inactive.3cd199d1.svg";
export { ForwardRef as ReactComponent };